<template>
    <div v-if="!this.id" class="flex flex-col gap-8 mb-8">
        <nav class="flex flex-none gap-4 justify-between items-center rounded-t-lg">
            <div class="flex-none">
                <FormButton
                    color="secondary"
                    icon="fa-chevron-left"
                    @click="$router.go(-1)">
                    Back
                </FormButton>
            </div>
        </nav>
    </div>
    <article>
        <form autocomplete="off" class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
            <input autocomplete="false" name="hidden" type="text" style="display:none;">
            <div class="flex flex-col gap-1">
                <label for="first_name" class="block text-sm font-medium leading-6 text-bhav-blue-300">
                    First Name <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
                </label>
                <TextInput placeholder="First Name" id="first_name" v-model="localItem.first_name" />
            </div>

            <div class="flex flex-col gap-1">
                <label for="last_name" class="block text-sm font-medium leading-6 text-bhav-blue-300">
                    Last Name <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
                </label>
                <TextInput placeholder="Last Name" id="last_name" v-model="localItem.last_name" />
            </div>

            <div class="flex flex-col gap-1">
                <label for="email" class="block text-sm font-medium leading-6 text-bhav-blue-300">
                    Email <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
                </label>
                <TextInput placeholder="Email" id="email" v-model="localItem.email" />
            </div>

            <div class="flex flex-col gap-1">
                <label for="password" class="block text-sm font-medium leading-6 text-bhav-blue-300">
                    Password <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
                </label>
                <input type="password" id="password" v-model="localItem.password" class="md:col-span-3 p-3 block w-full rounded-md text-bhav-blue-500 bg-bhav-cool-gray-50 focus:ring-1 ring-inset ring-oakwood-gray-300 placeholder:text-oakwood-gray-400 focus:ring-2 focus:ring-inset focus:ring-bhav-blue-600 sm:text-sm sm:leading-6" />
            </div>

            <div v-if="user.level > 1" class="flex flex-col gap-1 mt-4">
                <label for="position" class="block text-sm font-medium leading-5 text-bhav-blue-300 sm:mt-px sm:pt-2">
                    User Level <span class="text-oakwood-red cursor-help" title="This field is required">*</span>
                </label>
                <SelectField id="position" v-model="localItem.level" :new-collision-y=".8" :allow-null="!this.id" empty="Please Select..." :options="UserLevels.levels" />
            </div>
        </form>

        <footer class="mt-8 mb-4">
            <nav class="flex flex-none gap-4 justify-start items-center order-1 lg:order-2">
                <div>
                    <FormButton @click="update" :disabled="!valid" color="blue">
                        Save
                    </FormButton>
                </div>
            </nav>
        </footer>
        
    </article>
</template>

<script>
import axios from 'axios';
import { FormButton, SelectField, TextInput } from '@/components/form';
import { useAuthStore } from '@/stores/auth';
import { useMessageStore } from '@/stores/message';
import { mapState } from 'pinia';
import UserLevels from '@/enums/UserLevels';
import User from '@/models/user';

export default {
    setup() {
        const messageStore = useMessageStore();
        return {
            UserLevels,
            messageStore
        }
    },
    props: {
        id: {
            type: [Number, null],
            required: false,
            default: null
        },
        profile: {
            type: Boolean,
            required: false,
            default: false
        },
        item: {
            type: Object,
            required: false,
            default: () => new User
        },
        loading: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            localItem: new User
        }
    },
    methods: {
        update() {
            if(!this.id) {
                axios.post('users', this.localItem)
                    .then(() => {
                        this.$router.go(-1);
                    })
                    .catch(err => {
                        console.error(err);
                    });
            } else {
                let data = {...this.localItem};
                if(data.password === null) {
                    delete data.password;
                }
                axios.patch(`users/${this.id}`, data)
                    .then((resp) => {
                        if(this.profile) {
                            this.$emit('update-user', new User(resp.data));
                            this.setAlert({
                                text: 'Profile updated successfully!',
                                level: 'success'
                            });
                        } else {
                            this.$router.go(-1);
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        },
        resetForm() {
            this.localItem = {
                first_name: null,
                last_name: null,
                email: null,
                password: null,
                level: 1
            };
        }
    },
    watch: {
        item: {
            handler(newItem) {
                this.localItem = {...newItem};
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        ...mapState(useMessageStore, ['setAlert']),
        valid() {
            let required = this.localItem.first_name && this.localItem.last_name && this.localItem.email;
            if(!this.id) required = required && this.localItem.password;
            if(this.user.level !== null) required = required && this.localItem.level !== null;
            return required;
        }
    },
    components: {
        FormButton, SelectField, TextInput
    }
}
</script>